import { useContext } from 'react'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import usePaginationRule, { usePaginationRuleForm, useRelations } from '@hooks/usePaginationRule'
import { generateUrls } from '@hooks/useBrand'
import PageContext from '@contexts/pageContext'

import LinkToEntityModule from '@components/LinkToEntityModule'

import PageLayout from '../../../../components/PageLayout'
import PaginationRuleTools from '../../../../components/PaginationRuleTools'

import PaginationRuleDetails from '../PaginationRuleDetails'
import PaginationRulePublications from '../PaginationRulePublications'
import PaginationRuleSort from '../PaginationRuleSort'

const PageContent = (props: { paginationRuleId: number}) => {
  const { paginationRuleId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updatePaginationRule,
    },
  } = pageContext

  const paginationRulePayload = usePaginationRule({ id: paginationRuleId })
  const {
    paginationRule,
    callbacks: {
      updatePaginationRule: updateFn,
    },
    loading,
    updating,
  } = paginationRulePayload

  const paginationRuleFormPayload = usePaginationRuleForm(paginationRule, { validateOn: 'change' })
  const { entityState, saveEnabled } = paginationRuleFormPayload

  const relationsPayload = useRelations(paginationRule)
  const {
    brand,
    brand: {
      title: brandTitle,
      business_name: brandBusinessName,
      logo: brandLogo,
    },
  } = relationsPayload

  const { editBrandUrl } = generateUrls(brand)

  // @ts-expect-error TS2345
  const brandImageUrl = digObject(brandLogo, 'small', '')

  const updatePaginationRulePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Pagination Rule Updated',
  }

  return (
    <PageLayout entityPayload={paginationRulePayload} activeTabBarItemKey="details">
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <PaginationRuleDetails paginationRuleFormPayload={paginationRuleFormPayload} />

            <PaginationRuleSort
              paginationRule={paginationRule}
              paginationRuleFormPayload={paginationRuleFormPayload}
            />

            <PaginationRulePublications paginationRuleId={paginationRuleId} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                // @ts-expect-error TS2322
                marginLeft="auto"
                onClick={() => updatePaginationRule(updatePaginationRulePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <LinkToEntityModule
          entityTitle={brandTitle}
          goToHref={`${editBrandUrl}?redirect=${generateRedirectUrl()}`}
          imageUrl={brandImageUrl}
          loading={loading}
          moduleTitle="Brand"
          secondaryText={brandBusinessName}
        />
        <PaginationRuleTools paginationRulePayload={paginationRulePayload} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
